import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

export default function AdminCRM() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/crm").then((r) => setItems(r.data || [])); }, []);
  return (
    <div data-testid="admin-crm" className="space-y-8">
      <header>
        <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">CRM</div>
        <h1 className="editorial-h1 text-5xl mt-2">{items.length} contacts in the community.</h1>
      </header>
      <div className="card-elevated overflow-x-auto">
        <table className="w-full text-sm" data-testid="crm-table">
          <thead className="text-left text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">
            <tr className="border-b border-brand-line">
              <th className="p-4">Name</th><th className="p-4">Email</th><th className="p-4">Phone</th>
              <th className="p-4">Sources</th><th className="p-4">Interactions</th><th className="p-4">Last contact</th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="border-b border-brand-line last:border-0" data-testid={`crm-${c.id}`}>
                <td className="p-4 font-medium">{c.name}</td>
                <td className="p-4">{c.email}</td>
                <td className="p-4 text-brand-charcoal/70">{c.phone}</td>
                <td className="p-4"><div className="flex flex-wrap gap-1">{(c.sources || []).map((s) => (<span key={s} className="text-[10px] uppercase tracking-[0.18em] border border-brand-line rounded-full px-2 py-0.5">{s}</span>))}</div></td>
                <td className="p-4">{c.interactions}</td>
                <td className="p-4 text-xs text-brand-charcoal/55">{(c.last_contact || "").slice(0, 10)}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="6" className="p-8 text-center text-brand-charcoal/60">CRM will populate as people interact with Pop Panda.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
